import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ProfessionalOrderService {
    constructor(private http: HttpClient) { }

    getAll(params) {
        return this.http.get<any>(`${environment.apiUrl}/work-orders`, { params });
    }

    getOrder(/* id */) {
        return this.http.get<any>(`${environment.apiUrl}/work-orders/order`);
    }

    getOrderById(id) {
        return this.http.get<any>(`${environment.apiUrl}/work-orders/${id}`);
    }

    printOrder(id){
        return this.http.get<any>(`${environment.apiUrl}/work-orders/${id}/invoice`);
    }

    printOrderUrl(id){
        return `${environment.apiUrl}/work-orders/${id}/invoice`;
    }

    addPaymentProof(id,params){
        return this.http.post<any>(`${environment.apiUrl}/work-orders/${id}/payment-proof`,params);
    }

    cancelOrder(params) {
        return this.http.post<any>(`${environment.apiUrl}/work-orders/cancel-order`,params);
    }

    getCancelReasonsList() {
        return this.http.get<any>(`${environment.apiUrl}/work-orders/cancel-reasons`);
    }
}
